<template>
  <div class="donations fade-up" v-in-viewport.once>
    <div class="inner container">
      <div class="item">
        <p class="ttl font-34 f-roman">{{ _.get(getData, "title") }}</p>
        <div
          class="editor"
          v-html="_.get(getData, 'content.tabs.0.content')"
        ></div>
      </div>
      <div class="item">
        <picture>
          <source
            :srcset="_.get(getData, 'images.0.devices.mobile')"
            media="(max-width: 769px)"
          />
          <source
            :srcset="_.get(getData, 'images.0.devices.tablet')"
            media="(max-width: 1024px)"
          />
          <img
            :src="_.get(getData, 'images.0.devices.desktop')"
            :alt="_.get(getData, 'images.0.title.title')"
            class="absolute-img"
          />
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {};
  },
  computed: {
    getData() {
      return _.get(this.contentData, "data.list.0");
    }
  }
};
</script>

<style lang="scss">
.donations {
  &.fade-up.in-view-port {
    opacity: 1;
    transform: translateY(0px);
  }
  padding-top: 100px;
  padding-bottom: 100px;
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 1023px) {
      flex-direction: column;
    }
    .editor {
      margin-top: 57px;
      p {
        color: var(--white-no-blue2);
      }
      ul li {
        color: var(--secondary-txt);
        position: relative;
        padding-left: 20px;
        &::after {
          content: "";
          position: absolute;
          top: 5px;
          left: 0;
          width: 11px;
          height: 11px;
          border-radius: 50%;
          background-color: var(--secondary-txt);
          opacity: 0.5;
        }
      }
      @media (max-width: 1023px) {
        margin-top: 34px;
      }
    }
    .item {
      .ttl {
        color: var(--white-no-blue2);
        position: relative;
        display: inline;
      }
      &:first-child {
        width: calc(100% - 555px);
        padding-right: 20px;
        @media (max-width: 1365px) {
          width: 460px;
        }
        @media (max-width: 1023px) {
          width: 100%;
          padding-right: 0px;
        }
      }
      &:last-child {
        position: relative;
        width: 555px;
        padding-bottom: 51%;
        @media (max-width: 1365px) {
          width: 460px;
        }
        @media (max-width: 1023px) {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
